import { isArray, isNumber, isString } from 'util';

export class Criteria {
	public id: string;
	public cfg: string;
	public start_date: string;
	public end_date: string;
	public order_by: string;
	public order_direction: 'asc'|'desc';
	public limit: number;
	public offset: number;
	public adult_count: number;
	public max_price: number;
	public children_ages: Array<number>;
	public tags: Array<string>;
	public currency: string;
	public hotel_name: string;
	public service_code: string;
	public status?: string;
	public multi_room_occupancy?: string;
}

export function criteriaToQueryParams(criteria: Criteria): string {
	const urlSearchParams: URLSearchParams = new URLSearchParams();

	Object.keys(criteria).forEach(key => {
		let value = criteria[key];

		if (isArray(value)) {
			value = !!(Array<any>(criteria[key]).length) ? Array<any>(criteria[key]).join(',') : '';
		}

		if (isNumber(value)) {
			value = (<number>value).toString(10);
		}

		if (!isString(value)) {
			value = '';
		}

		if (!!((<string>value).length)) {
			urlSearchParams.set(key, value);
		}
	});

	return urlSearchParams.toString();
}

export function criteriaToPostParams(criteria: Criteria): object {
	const postBody: object = {};

	Object.keys(criteria).forEach(key => {
		if (
			(isArray(criteria[key]) && !!(criteria[key].length))
			|| (isString(criteria[key]) && !!(criteria[key].length))
			|| (isNumber(criteria[key]) && criteria[key] >= 0)
		) {
			if ((key === 'max_price' || key === 'limit') && criteria[key] < 1) {
				return;
			}

			postBody[key] = criteria[key];
		}
	});

	return postBody;
}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/models/criteria.ts